import React, { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import { ChartBarIcon } from '@heroicons/react/24/outline';
import IconSection from '../../../_new_card_components/IconSection';

export default function Filled(props) {
  const { event } = props;

  const [timestamp] = useState(new Date().toISOString());

  const invitations = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          response: 'Yes',
          eventId: event.id,
          createdAt: {
            $lte: timestamp
          }
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  });

  if (invitations.state === PayloadStates.FETCHING) {
    return (
      <IconSection
        icon={ChartBarIcon}
        title="..."
        tooltip="Percent filled"
      />
    );
  }

  if (!event.data.slots) {
    return (
      <IconSection
        icon={ChartBarIcon}
        title="?"
        tooltip="Percent filled"
      />
    );
  }

  const percent = Math.floor(invitations.data.length / event.data.slots * 100);

  return (
    <IconSection
      icon={ChartBarIcon}
      title={`${percent}%`}
      tooltip="Percent filled"
    />
  );
}
